import React, { useContext, useState } from "react";
import { urls } from "../URLs";
import {
  BASE_URL_API_TRANXT_API,
  BASE_URL_APISERVICES,
} from "../utils/Constants";
import { useHistory } from "react-router";
import swal from "sweetalert";
import cogoToast from "cogo-toast";
import { GlobalContext } from "../Context/GlobalState";
import { auth } from "../utils/firebase/firebase.config";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { generateHashKey2, encryptRequest } from "../utils/utilFuctions";
import {adminAuth} from "../config"
import "./UnlockUser.css";
import { API_ENDPOINTS } from "../utils/apiEndpoints";

export default function UnlockUser() {
  const history = useHistory();
  const { login: loginUrl } = urls;
  const [userName, setUserName] = useState("");
  const [userPan, setUserPan] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpValidated, setOtpValidated] = useState(false);
  const [forgetSuccess, setForgetSuccess] = useState(false);
  const [textOtp, setTextOtp] = useState("");
  const [resendOtpEnable, setResendOtpEnable] = useState(false);
  const [seconds, setSeconds] = useState(60);
  const { setTransactionLoaderState, setUserInfo, user } =
    useContext(GlobalContext);
  const [formErrors1, setFormErrors1] = useState({ mobile: "" });
  const [formErrors4, setFormErrors4] = useState({ pan: "" });
  const [formErrors3, setFormErrors3] = useState({ otp: "" });
  const [country, setCountry] = useState("+91");
  const [formErrors2, setFormErrors2] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [passShow, setPassShow] = useState(false);
  const [passShow2, setPassShow2] = useState(false);
  const [loading, setLoading] = useState(false);
  const { username, password } = adminAuth;
  // Optional Firebase OTP flow (currently not wired into validate1)
  function onCaptchVerify() {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {},
          "expired-callback": () => {},
        },
        auth
      );
      onSignup();
    }
  }

  function onSignup() {
    onCaptchVerify();

    const appVerifier = window.recaptchaVerifier;
    const formatPh = country + userName;
    console.log(formatPh);

    signInWithPhoneNumber(auth, formatPh, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        cogoToast.success("OTP sent successfully!");
        setOtpSent(true);
        setResendOtpEnable(false);
        setSeconds(60);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }

  function onOTPVerify() {
    setLoading(true);
    window.confirmationResult
      .confirm(textOtp)
      .then(async (res) => {
        cogoToast.success("OTP validated successfully!");
        setOtpValidated(true);
      })
      .catch((err) => {
        cogoToast.error("Invalid OTP");
        console.log(err);
      });
  }

  const goTOLoginScreen = () => history.push("/");

  const sendOTP = async () => {
    setTransactionLoaderState(true);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Basic " + Buffer.from(username + ":" + password).toString("base64")
      );
      

    const encryptedRequest = encryptRequest([userName, "9", userPan]);

    const raw = JSON.stringify({
      data: encryptedRequest,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.unlockUser}`,
        requestOptions
      );
      const data = await res.json();
      if (data.responseCode === "00") {
        cogoToast.success(data.responseMessage.toString());
        setOtpSent(true);
      } else {
        cogoToast.error(data.responseMessage.toString());
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  const validateOTP = async () => {
    setTransactionLoaderState(true);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Basic " + Buffer.from(username + ":" + password).toString("base64")
      );

    const encryptedRequest = encryptRequest([userName, "9", textOtp]);

    const raw = JSON.stringify({
      data: encryptedRequest,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.unlockUserValidateOtp}`,
        requestOptions
      );
      const data = await res.json();
      setTransactionLoaderState(false);

      if (data.responseCode === "00") {
        cogoToast.success(data.responseMessage?.toString() || "Success");
        setOtpValidated(true);
      } else {
        swal(
          "Failed",
          data.responseMessage || data.msg || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("Error", "Something went wrong, please try again", "error");
    }
  };

  const changePassword = async () => {
    setTransactionLoaderState(true);
    try {
      const raw = JSON.stringify({
        mobileno: userName,
        reset_type: "PASSWORD",
        password: newPassword,
        currenttpin: textOtp,
      });

      const hash_key = await generateHashKey2(userName);
      const myHeaders = new Headers();
      myHeaders.append("HASH_KEY", hash_key);
      myHeaders.append("Content-Type", "application/json");
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_API}/api/Profile/updatepwd.aspx`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "00") {
        setNewPassword("");
        setConfirmPassword("");
        setForgetSuccess(true);
        swal("Success", `Password changed successfully`, "success");
      } else {
        swal("Failed", "Password change failed", "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  const validate1 = () => {
    let mobileError = "";
    let panError = "";

    if (!userName || userName.length !== 10) {
      mobileError = "Please enter valid mobile number";
    }

    if (!userPan || userPan.length !== 10) {
      panError = "Please enter valid PAN number";
    }

    setFormErrors1({ mobile: mobileError });
    setFormErrors4({ pan: panError });

    if (mobileError || panError) {
      return;
    }

    // Current flow uses backend OTP, not Firebase
    sendOTP();
  };

  const validate2 = () => {
    let errors = {};
    if (newPassword.length < 8) {
      errors.newPassword = "Password should be at least 8 characters long";
    } else if (newPassword !== confirmPassword) {
      errors.confirmPassword =
        "New Password and Confirm Password should be the same";
    }
    setFormErrors2(errors);
    if (Object.keys(errors).length === 0) {
      changePassword();
    }
  };

  const validate3 = () => {
    let errors = {};
    if (textOtp.length < 6) {
      errors.otp = "Please enter valid OTP";
    }
    setFormErrors3(errors);
    if (Object.keys(errors).length === 0) {
      validateOTP();
    }
  };

  const showNewPassword = () => {
    setPassShow(!passShow);
  };

  const showConfirmPassword = () => {
    setPassShow2(!passShow2);
  };

  return (
    <div className="row justify-content-center align-items-center my-auto mx-auto mt-5 unlock-container">
      <div id="recaptcha-container"></div>
      <div className="col-lg-4 col-md-8 col-sm-10 mx-auto">
        {forgetSuccess && <ForgetSuccess history={history} />}

        {!forgetSuccess && (
          <div className="card text-left p-4 unlock-card">
            <h4 className="unlock-title">Unblock User</h4>

            {!otpSent && (
              <>
                <div className="form-group mb-3">
                  <label className="font-weight-bold unlock-label">
                    Mobile Number
                  </label>

                  <div className="input-group unlock-input-group">
                    <div className="input-group-prepend unlock-country-prepend">
                      <select
                        onChange={(e) => setCountry(e.target.value)}
                        className="unlock-country-select"
                      >
                        {["+91", "+1"].map((en) => (
                          <option key={en}>{en}</option>
                        ))}
                      </select>
                    </div>

                    <input
                      type="text"
                      className="form-control unlock-input"
                      placeholder="Enter mobile number"
                      onChange={(e) => {
                        setFormErrors1({ mobile: "" });
                        setUserName(e.target.value);
                      }}
                    />
                  </div>

                  <p className="text-danger p-0 m-0 unlock-error">
                    {formErrors1.mobile}
                  </p>
                </div>

                <div className="form-group mb-3">
                  <label className="font-weight-bold unlock-label">
                    PAN Card Number
                  </label>

                  <input
                    type="text"
                    className="form-control unlock-input"
                    placeholder="Enter PAN card number"
                    onChange={(e) => {
                      setFormErrors4({ pan: "" });
                      setUserPan(e.target.value);
                    }}
                  />
                  <p className="text-danger p-0 m-0 unlock-error">
                    {formErrors4.pan}
                  </p>
                </div>

                <div className="row mt-2">
                  <button
                    className="btn w-100 unlock-primary-btn"
                    onClick={validate1}
                  >
                    Send OTP
                  </button>
                </div>
              </>
            )}

            {otpSent && !otpValidated && (
              <>
                <div className="form-group">
                  <label className="unlock-label">OTP</label>
                  <div className="input-group">
                    <input
                      type="password"
                      className="form-control unlock-input"
                      placeholder="Enter OTP"
                      onChange={(e) => {
                        setError("");
                        setTextOtp(e.target.value);
                      }}
                      value={textOtp}
                    />
                  </div>
                  <p className="text-danger text-left p-0 unlock-error">
                    {formErrors3.otp}
                  </p>
                </div>
                <div className="row">
                  <button
                    className="btn unlock-primary-btn w-100"
                    onClick={validate3}
                  >
                    Validate OTP
                  </button>
                </div>
              </>
            )}

            {otpValidated && (
              <>
                <div className="form-group">
                  <label className="unlock-label">New Password</label>
                  <div className="input-group">
                    <div className="input-group-prepend bg-transparent">
                      <span className="input-group-text bg-transparent border-right-0 no-glow">
                        <i className="mdi mdi-lock-outline text-primary"></i>
                      </span>
                    </div>
                    <input
                      type={passShow ? "text" : "password"}
                      className="form-control form-control-lg border-left-0 border-right-0 no-glow unlock-input"
                      placeholder="New password"
                      onChange={(e) => {
                        setError("");
                        setNewPassword(e.target.value);
                      }}
                      value={newPassword}
                    />
                    <div className="input-group-prepend bg-transparent">
                      <span
                        className="input-group-text bg-transparent border-left-0 no-glow"
                        onClick={showNewPassword}
                      >
                        <i
                          className={`mdi text-primary ${
                            passShow ? "mdi-eye" : "mdi-eye-off"
                          }`}
                        ></i>
                      </span>
                    </div>
                  </div>
                  <p className="text-danger text-left p-0 unlock-error">
                    {formErrors2.newPassword}
                  </p>
                </div>

                <div className="form-group">
                  <label className="unlock-label">Confirm Password</label>
                  <div className="input-group">
                    <div className="input-group-prepend bg-transparent">
                      <span className="input-group-text bg-transparent border-right-0 no-glow">
                        <i className="mdi mdi-lock-outline text-primary"></i>
                      </span>
                    </div>
                    <input
                      type={passShow2 ? "text" : "password"}
                      className="form-control form-control-lg border-left-0 border-right-0 no-glow unlock-input"
                      placeholder="Confirm password"
                      onChange={(e) => {
                        setError("");
                        setConfirmPassword(e.target.value);
                      }}
                      value={confirmPassword}
                    />
                    <div className="input-group-prepend bg-transparent">
                      <span
                        className="input-group-text bg-transparent border-left-0 no-glow"
                        onClick={showConfirmPassword}
                      >
                        <i
                          className={`mdi text-primary ${
                            passShow2 ? "mdi-eye" : "mdi-eye-off"
                          }`}
                        ></i>
                      </span>
                    </div>
                  </div>
                  <p className="text-danger text-left p-0 unlock-error">
                    {formErrors2.confirmPassword}
                  </p>
                </div>
                <div className="row">
                  <button
                    className="btn unlock-primary-btn w-100"
                    onClick={validate2}
                  >
                    Reset Password
                  </button>
                </div>
              </>
            )}

            <div className="row mt-3">
              <button
                className="btn btn-outline-primary w-100 unlock-back-btn"
                onClick={goTOLoginScreen}
              >
                <span className="mdi mdi-arrow-left"> </span>
                Back To Login
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const ForgetSuccess = ({ history }) => {
  const goTOLoginScreen = () => history.push("/");
  return (
    <div className="card text-left p-4 unlock-card">
      <div className="row flex-column align-items-center unlock-success">
        <img
          className="my-2"
          src={require("../../assets/images/success_tick.png")}
          style={{ height: "4rem", width: "auto" }}
          alt="success"
        />
        <span style={{ fontWeight: "700" }} className="my-2">
          Password Changed Successfully
        </span>
        <span className="my-2">Please login to your account</span>
        <button
          className="btn btn-primary btn-block rounded-0 my-2 unlock-primary-btn"
          onClick={goTOLoginScreen}
        >
          Login Now
        </button>
      </div>
    </div>
  );
};
